export function setOrderResp(state, payload) {
  return {
    ...state,
    orderResp: payload
  };
}

export function addOrderErrorResp(state, payload) {
  return {
    ...state,
    orderErrorResp: [...state.orderErrorResp, payload]
  };
}
